import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ThemeContextProvider } from "./theme/ThemeContext";
import { store } from "./store";
import { router } from "./router";

export function App() {
  return (
    <Provider store={store}>
      <ThemeContextProvider>
        <RouterProvider router={router} />
      </ThemeContextProvider>
    </Provider>
  );
}
